/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Save_AnywayInputs */

const en_us2_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save anyway`)
};

const pt_br2_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar mesmo assim`)
};

const es_419_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar igual`)
};

const pt_pt2_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar mesmo assim`)
};

const fr_fr2_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer quand même`)
};

const de_de2_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trotzdem speichern`)
};

const it_it2_workout_quick_save_anyway = /** @type {(inputs: Workout_Quick_Save_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva comunque`)
};

/**
* | output |
* | --- |
* | "Save anyway" |
*
* @param {Workout_Quick_Save_AnywayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_save_anyway = /** @type {((inputs?: Workout_Quick_Save_AnywayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Save_AnywayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_save_anyway(inputs)
	if (locale === "es-419") return es_419_workout_quick_save_anyway(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_save_anyway(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_save_anyway(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_save_anyway(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_save_anyway(inputs)
	return en_us2_workout_quick_save_anyway(inputs)
});
export { workout_quick_save_anyway as "workout-quick.save_anyway" }